<div class="notify-container" *ngIf="(messagesSubject | async).length">
  <ng-container *ngFor="let item of messagesSubject | async; let i = index">
    <div
      class="notify-item d-flex flex-direction-column"
      [class.error]="item.type === 'error'"
      [class.success]="item.type === 'success'"
      [class.warning]="item.type === 'warning'"
      [class.simple]="item.type === 'simple'"
      [class.dark]="(currentThemeSubject | async) === 'dark'"
      [class.light]="(currentThemeSubject | async) === 'light'"
    >
      <button class="closeIcon" mat-icon-button (click)="onClose(i)"><mat-icon>close</mat-icon></button>

      <div class="d-flex align-items-center ml-8">
        <div class="icon-container" *ngIf="item.withAlertIcon">
          <mat-icon class="hint-icon" *ngIf="item.type === 'error'" svgIcon="error_hint"></mat-icon>
          <mat-icon class="hint-icon" *ngIf="item.type === 'success'" svgIcon="success_hint"></mat-icon>
          <mat-icon class="hint-icon" *ngIf="item.type === 'warning'" svgIcon="warning_hint"></mat-icon>
          <mat-icon class="hint-icon" *ngIf="item.type === 'simple'" svgIcon="simple_hint"></mat-icon>
        </div>
        <div class="message-container">
          <span *ngIf="item.title" class="t-body-text-medium ml-8">{{ item.title | translate | async }}</span>
          <ul
            *ngIf="!item.template"
            class="m-0 p-0 ml-8 mr-8"
            [class.mt-8]="item.title"
            [class.single]="item.message.length < 2"
            [class.pl-16]="item.message.length > 1"
          >
            <li *ngFor="let message of item.message">{{ message | translate | async | addPunctuation }}</li>
          </ul>
        </div>

        <div class="m-0 p-0 mr-20" *ngIf="item.template">
          <ng-container
            [ngTemplateOutlet]="item.template.templateRef"
            [ngTemplateOutletContext]="{ $implicit: { entity: item } }"
          ></ng-container>
        </div>
      </div>

      <div class="actions d-flex justify-content-end mr-8">
        <ng-container *ngIf="item.action">
          <button mat-button (click)="onAction(item)" class="t-caption-semibold">
            {{ item.action | translate | async }}
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
